/**
 *  参数设置
 * */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './index.module.scss';
import CusotmUpload, { generateFileList } from '@/components/NewUpload';
import { message, InputNumber, Spin, Empty, Input } from 'antd';
import { XOKButton, } from '@/components/xqxc_ui';
import http from '@/assets/api/http';
import PropTypes from 'prop-types';
import model from '@/reducers/system/parameter/model';
import { regYuanToFen, regFenToYuan } from '@/util/money';
import { FloatConversion } from '@/util/conversion';


class RiskControl extends Component {
    state = {
        loading: false,
        floatConversion: new FloatConversion(),
        riskList: [],//渲染的数据
        spinLoading: true,
    };

    componentDidMount() {
        this.props.getlistAdminParamByParamType({ paramType: 'RIDER_INSURE_SET' });
    }

    componentDidUpdate(prevProps) {
        if (this.props.listAdminParamByParamType !== prevProps.listAdminParamByParamType) {
            this.renderRisk(this.props.listAdminParamByParamType);
        }
    }

    //保存
    _savehandle = () => {
        const { riskList, floatConversion } = this.state;
        let submit = riskList.map((item) => {
            if (item.paramCode == 'INSURE_AMOUNT' || item.paramCode == 'ACCIDENTAL_DISABILITY_INSURE_AMOUNT' || item.paramCode == 'ACCIDENTAL_MEDICAL_INSURE_AMOUNT' ||
            item.paramCode == 'ACCIDENTAL_HOSPITAL_INSURE_AMOUNT' || item.paramCode == 'INJURY_PROPERTY_DAMAG_INSURE_AMOUNT'
            ) {
                return { paramCode: item.paramCode, paramValue: Number(regYuanToFen(item.paramValue)) }
            } else {
                return { paramCode: item.paramCode, paramValue: item.paramValue };
            }  
            
        }); 

        this.setState({ loading: true }, () => {
            http('/?cmd=com.xqxc.api.pig.mis.biz.platform.AdminParamMisService.batchSaveParam', { list: submit }, 'POST').then((response) => {
                message.success('保存成功');
                this.props.getlistAdminParamByParamType({ paramType: 'RIDER_INSURE_SET' });
                this.setState({ loading: false });
            }).catch((e = {}) => {
                message.error(e.message);
                this.setState({ loading: false });
            });
        });
    }

    renderRisk = (obj) => {
        const { floatConversion } = this.state;
        let risk = [];
        if (Object.keys(obj).length > 0) {
            let arr = [];
            for (let key in obj) {
                arr.push(obj[key]);
            }

            risk = arr.map((v) => {
                switch (v.paramCode) {
                    case 'INSURE_LOGO'://保险logo
                        {
                            v.attr = v.paramAttr;
                            // v.aprecision = 0;
                            // v.amin = 1;
                            // v.amax = 10;
                            v.aremark = v.remark;
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'INSURE_TEL'://保险理赔电话
                        {
                            v.attr = v.paramAttr;
                            // v.aprecision = 0;
                            // v.amin = 1;
                            // v.amax = 9999;
                            v.aremark = v.remark;
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'INSURE_AMOUNT'://保险费用
                        {
                            v.attr = v.paramAttr;
                            v.aprecision = 2;
                            v.amin = 0;
                            v.amax = 100;
                            v.aremark = v.remark;
                            v.paramValue = Number(regFenToYuan(v.paramValue));
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'ACCIDENTAL_DISABILITY_INSURE_AMOUNT'://意外身故、残疾保额
                        {
                            v.attr = v.paramAttr;
                            v.aprecision = 0;
                            v.amin = 0;
                            v.amax = 10000000;
                            v.aremark = v.remark;
                            v.paramValue = Number(regFenToYuan(v.paramValue));
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'ACCIDENTAL_MEDICAL_INSURE_AMOUNT'://意外医疗保额
                        {
                            v.attr = v.paramAttr;
                            v.aprecision = 0;
                            v.amin = 0;
                            v.amax = 10000000;
                            v.aremark = v.remark;
                            v.paramValue = Number(regFenToYuan(v.paramValue));
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'ACCIDENTAL_HOSPITAL_INSURE_AMOUNT'://意外住院津贴保额
                        {
                            v.attr = v.paramAttr;
                            v.aprecision = 0;
                            v.amin = 0;
                            v.amax = 10000000;
                            v.aremark = v.remark;
                            v.paramValue = Number(regFenToYuan(v.paramValue));
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'INJURY_PROPERTY_DAMAG_INSURE_AMOUNT'://第三者人身伤害/财产损失责任保额
                        {
                            v.attr = v.paramAttr;
                            v.aprecision = 0;
                            v.amin = 0;
                            v.amax = 10000000;
                            v.aremark = v.remark;
                            v.paramValue = Number(regFenToYuan(v.paramValue));
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'INSURE_SIGN_PROMPT'://保险签约提示
                        {
                            v.attr = v.paramAttr;
                            // v.aprecision = 0;
                            // v.amin = 1;
                            // v.amax = 999;
                            v.aremark = v.remark;
                            // v.paramValue = Number(regFenToYuan(v.paramValue));
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                    case 'INSURE_UNSIGN_PROMPT'://保险解除签约提示
                        {
                            v.attr = v.paramAttr;
                            // v.aprecision = 0;
                            // v.amin = 1;
                            // v.amax = 999;
                            v.aremark = v.remark;
                            // v.paramValue = Number(regFenToYuan(v.paramValue));
                            let { paramAttr, paramType, remark, ...resetParams } = v;
                            return resetParams;
                        }
                }
                return v;
            });

        }
        this.setState({ riskList: risk, spinLoading: false });
    }

    render() {
        const { loading, riskList } = this.state;

        return (
            <div className={styles.flexBoxContainer}>
                <div className={styles.tableContainer} style={{ overflow: 'hidden auto' }}>
                    {riskList.length > 0 ? riskList.map((v, index) => {
                        return (
                            <div className={styles.riskcontent} key={index}>
                                <div className={styles.item}>
                                    <h4>{v.attr}</h4>
                                    <p>{v.aremark}</p>
                                    {v.paramCode == 'INSURE_TEL' || v.paramCode == 'INSURE_SIGN_PROMPT' || v.paramCode == 'INSURE_UNSIGN_PROMPT' ?
                                        <div>
                                            <Input
                                                inputStyle={{ width: '200px' }}
                                                placeholder='请输入'
                                                value={v.paramValue}
                                                onChange={(value) => {
                                                    let arrt = this.state.riskList.map((item) => {
                                                        if (item.paramCode == v.paramCode) {
                                                            item.paramValue = value ? value.target.value : '';
                                                            return item;
                                                        }
                                                        return item;
                                                    });
                                                    this.setState({ riskList: arrt });
                                                }}
                                            />
                                        </div> :
                                        v.paramCode == 'INSURE_LOGO' ?                 
                                            <CusotmUpload
                                                className={styles.CusotmUploadStyle}
                                                accept='.png, .jpg, .jpeg'
                                                listType="picture-card"
                                                wallMode='single'
                                                removeError
                                                fileList={v.paramValue ? generateFileList(v.paramValue) : generateFileList('')}
                                                qiniuUploadProps={{ uploadType: 'image' }}
                                                onFileListChange={file => {
                                                    let url = file.fileList[0] ? file.fileList[0].url : '';
                                                    let arrt = this.state.riskList.map((item) => {
                                                        if (item.paramCode == v.paramCode) {
                                                            item.paramValue = url;
                                                            return item;
                                                        }
                                                        return item;
                                                    });
                                                    this.setState({ riskList: arrt });
                                                }}
                                                beforeUpload={file => {
                                                    const isType = ['image/png', 'image/jpeg', 'image/jpg'];
                                                    const isGt3M = file.size / 1024 / 1024 > 3;
                                                    if (!isType.includes(file.type)) {
                                                        message.warn('只能上传 .png, .jpg, .gif 格式的文件!');
                                                        file.status = 'error';
                                                        return false;
                                                    }
                                                    if (isGt3M) {
                                                        message.warn('图片必须小于 3M!');
                                                        file.status = 'error';
                                                        return false;
                                                    }
                                                }}
                                            >
                                                <div style={{ color: '#999999', fontSize: '12px' }}>上传文件</div>
                                            </CusotmUpload>                                       
                                            :
                                            <div>
                                                <InputNumber
                                                    inputStyle={{ width: '100px' }}
                                                    placeholder='请输入'
                                                    // defaultValue={v.paramValue}
                                                    value={v.paramValue}
                                                    precision={v.aprecision}
                                                    min={v.amin}
                                                    max={v.amax}
                                                    onChange={(value) => {
                                                        let arrt = this.state.riskList.map((item) => {
                                                            if (item.paramCode == v.paramCode) {
                                                                item.paramValue = value ? value : v.amin;
                                                                return item;
                                                            }
                                                            return item;
                                                        });
                                                        this.setState({ riskList: arrt });
                                                    }}
                                                />
                                            </div>
                                    }

                                </div>
                            </div>
                        );
                    }) : null}
                </div>
                <div className={styles.layout}>
                    <XOKButton loading={loading} onClick={this._savehandle} style={{ marginTop: '30px' }} label='保存' />
                </div>
            </div>
        );
    }
}

RiskControl.propTypes = {
    listAdminParamByParamType: PropTypes.array,
    getlistAdminParamByParamType: PropTypes.func,//参数数据(action)
};

const mapStateToProps = (state) => ({
    listAdminParamByParamType: state.parameter.listAdminParamByParamType,
});

export default connect(mapStateToProps, { ...model.actions })(RiskControl);